import { BuildingsLayer, PointsLayer, LinesLayer } from '../services/mapLayerService';
import get from 'lodash/get';
import { vuetifyColors } from '../utils/themes';

let mapConfig = {
  light: {
    options: {
      style: 'mapbox://styles/mapbox/light-v9',
      container: 'map',
      center: [6.97899, 50.93945],
      zoom: 18,
      zoomNear: 17,
    },
  },
  dark: {
    options: {
      style: 'mapbox://styles/mapbox/dark-v10',
      container: 'map',
      center: [6.97899, 50.93945],
      zoom: 18,
      zoomNear: 17,
    },
  },
};

export default {
  isValidMapName(mapName) {
    return Object.keys(mapConfig).indexOf(mapName) > -1;
  },
  getMapConfig(mapName) {
    if (this.isValidMapName(mapName)) {
      return mapConfig[mapName];
    }
  },
  getOptions(mapName) {
    return get(this.getMapConfig(mapName), 'options');
  },
  getStyle(mapName) {
    return get(this.getOptions(mapName), 'style');
  },
  getAccessToken() {
    const token = process.env.VUE_APP_MAPBOX_TOKEN;
    if (!token) {
      throw new Error('VUE_APP_MAPBOX_TOKEN is not set in environment variables');
    }
    return token;
  },
  mapExist(map) {
    return map !== undefined && typeof map === 'object' && map && Boolean(map);
  },
  layersCreated(map) {
    if (this.mapExist(map)) {
      if (map.getSource('points') || map.getSource('lines')) {
        return true;
      }
    }
    return false;
  },
  addDefaultLayers(map) {
    if (!this.mapExist(map) || this.layersCreated(map)) {
      return;
    }
    map.addLayer(BuildingsLayer);
    // map.addSource('points', PointsSource)
    map.addLayer(PointsLayer);
    // map.addSource('lines', LinesSource)
    map.addLayer(LinesLayer);
  },
  add3DBuildingLayer(map) {
    if (!this.mapExist(map) || this.layersCreated(map)) {
      return;
    }
    map.addLayer(BuildingsLayer);
  },
  remove3DBuildingLayer(map) {
    if (!this.mapExist(map)) {
      return;
    }

    const has3dBuildingsLayer = map.getStyle().layers.find((layer) => layer.id === BuildingsLayer.id);

    if (!has3dBuildingsLayer) {
      console.warn('3d buildings layer not found, skipping removal');
      return;
    }

    map.removeLayer(BuildingsLayer.id);
  },
  addBuildingsLayer(localMap) {
    var layers = localMap.getStyle().layers;

    var labelLayerId;
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].type === 'symbol' && layers[i].layout['text-field']) {
        labelLayerId = layers[i].id;
        break;
      }
    }
    localMap.addLayer(
      {
        id: '3d-buildings',
        source: 'composite',
        'source-layer': 'building',
        filter: ['==', 'extrude', 'true'],
        type: 'fill-extrusion',
        minzoom: 15,
        paint: {
          'fill-extrusion-color': '#aaa',
          // use an 'interpolate' expression to add a smooth transition effect to the
          // buildings as the user zooms in
          'fill-extrusion-height': 3,
          // [
          //   'interpolate', ['linear'], ['zoom'],
          //   3, 0,
          //   3.05, ['get', 'height']
          // ],
          'fill-extrusion-base': 3,
          //  [
          //   'interpolate', ['linear'], ['zoom'],
          //   3, 0,
          //   3.05, ['get', 'min_height']
          // ],
          'fill-extrusion-opacity': 0.6,
        },
      },
      labelLayerId
    );
  },
  markerColor(color, store) {
    if (vuetifyColors[color]) {
      return vuetifyColors[color];
    }
    let fallback = null;
    if (store) {
      if (store.state.app.UiTheme) {
        fallback = store.state.app.colorHexDark || store.state.app.colorHexLight;
      } else {
        fallback = store.state.app.colorHexLight || store.state.app.colorHexDark;
      }
    }
    return fallback || vuetifyColors['success'];
  },
  convertToRgbaValues(hexColor) {
    if (/^#?([A-Fa-f0-9]{3}){1,2}$/.test(hexColor)) {
      let c = hexColor.substring(1).split('');
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = `0x${c.join('')}`;
      return [(c >> 16) & 255, (c >> 8) & 255, c & 255];
    }
    return [0, 0, 0];
  },
  convertToRgba(hexColor, alpha = 1.0) {
    return `rgba(${this.convertToRgbaValues(hexColor).join(',')},${alpha})`;
  },
  mixRgbaColor(hexColor1, hexColor2, mix = 0.5, alpha = 1.0) {
    const values1 = this.convertToRgbaValues(hexColor1);
    const values2 = this.convertToRgbaValues(hexColor2);

    const mixValues = values1.map((v, idx) => {
      return v * (1 - mix) + values2[idx] * mix;
    });
    return `rgba(${mixValues.join(',')},${alpha})`;
  },
};
